import React from 'react';
import webCore from '@happylife-a/web-core';
import { Input, InputGroup, InputRightElement, Icon } from '@chakra-ui/react';
import { theme } from '../../../theme';

export default function NotfoundSearch({ value, onChange, onKeyUp }) {
  const { t } = webCore.contexts.useTranslation();

  return (
    <InputGroup w="100%" maxW="460px">
      <InputRightElement pointerEvents="none" h={12} w={12}>
        <Icon
          as={theme.icons.SearchIconPink}
          color={theme.colors.primary[500]}
          fill="none"
          w={6}
          h={6}
        />
      </InputRightElement>
      <Input
        h={12}
        type="text"
        placeholder={t('Search')}
        borderRadius="66px"
        bg="rgba(255, 255, 255, 0.13);"
        boxShadow="none"
        _placeholder={{
          color: 'primary.500',
        }}
        borderWidth={1}
        borderColor="primary.500"
        borderStyle="solid"
        _focus={{ boxShadow: 'none', borderColor: 'grey.300' }}
        _hover={{ borderColor: 'grey.300' }}
        value={value}
        onChange={onChange}
        onKeyUp={onKeyUp}
      />
    </InputGroup>
  );
}
